import { createAsyncThunk } from '@reduxjs/toolkit';
import { atsJobCreateActions } from './atsJobCreateReducer';
import { createApiAction } from '../shared/createApiAction';
import type { ApiRequestOptions, ThunkArgs } from '../shared/createApiAction';

// todo: need to update these, for now added some sample
const actionsConfig = {
  getCurrentJob: {
    method: 'get',
    endpoint: '/ats_jobs/:jobId',
    thunkName: 'currentJob',
    reducerName: 'currentJob',
    responseKey: 'data',
  },
  getOffices: {
    method: 'get',
    endpoint: '/ats_offices',
    thunkName: 'getOffices',
    reducerName: 'getOffices',
    responseKey: 'data',
  },
  getHiringTeam: {
    method: 'get',
    endpoint: '/ats_jobs/:jobId/ats_hiring_teams',
    thunkName: 'hiringTeam',
    reducerName: 'hiringTeam',
    responseKey: 'data',
  },
  updateHiringTeam: {
    method: 'put',
    endpoint: 'ats_jobs/:jobId/ats_hiring_teams',
    thunkName: 'updatedHiringTeam',
    reducerName: 'updatedHiringTeam',
    // responseKey: 'data',
  },
  getJobPost: {
    method: 'get',
    endpoint: '/ats_jobs/:jobId/ats_job_post',
    thunkName: 'getJobPost',
    reducerName: 'getJobPost',
    responseKey: 'data',
  },
  getDefaultJobPost: {
    method: 'get',
    endpoint: '/ats_jobs/:jobId/ats_job_post/new',
    thunkName: 'getDefaultJobPost',
    reducerName: 'defaultJobPost',
    responseKey: 'data',
  },
  // Same endpoint as getDefaultJobPost, but parked in its own slice. The job
  // post `show` response stops returning `ats_form_templates` once a job has
  // had a distinct employee form, which leaves the template pickers with no
  // options to pick from. `new` always returns the list. It needs a separate
  // reducer key because `defaultJobPost` outranks the saved job post in
  // formOptions / resolveEmployeeFormTemplate — writing there would swap the
  // rendered form over to source-template data. See ENG-3654.
  getFormTemplateOptions: {
    method: 'get',
    endpoint: '/ats_jobs/:jobId/ats_job_post/new',
    thunkName: 'getFormTemplateOptions',
    reducerName: 'formTemplateOptions',
    responseKey: 'data',
  },
  createJobPost: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/ats_job_post',
    thunkName: 'createJobPost',
    reducerName: 'createJobPost',
  },
  updateJobPost: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/ats_job_post',
    thunkName: 'createJobPost',
    reducerName: 'createJobPost',
  },
  deleteJobPostField: {
    method: 'patch',
    endpoint: '/ats_jobs/:jobId/ats_job_post',
    thunkName: 'updateJobPost',
    reducerName: 'updateJobPost',
  },
  getInterviewPlan: {
    method: 'get',
    endpoint: '/ats_jobs/:jobId/ats_job_stages',
    thunkName: 'getInterviewPlan',
    reducerName: 'getInterviewPlan',
    responseKey: 'data',
  },
  getInterviewPools: {
    method: 'get',
    endpoint: '/user_groups?type=ats_interviewer_pool',
    thunkName: 'getInterviewPools',
    reducerName: 'getInterviewPools',
    responseKey: 'data',
  },
  getHackerrankStatus: {
    method: 'get',
    endpoint: '/hacker_rank/list_interview_templates',
    thunkName: 'getHackerrankStatus',
    reducerName: 'getHackerrankStatus',
    responseKey: 'data',
  },
};

const apiAction = createApiAction({
  actions: atsJobCreateActions,
  // AtsJobWrapper's 403 -> "no access" screen reads this status.
  errorPayload: (error) => ({ status: error.status }),
});

export const atsJobCreateApiActions = (
  actionId,
  config: ApiRequestOptions = {}
) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for ats job create');

  const { endpoint, thunkName } = currentAction;

  if (isApi) {
    return (...args: ThunkArgs) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args: ThunkArgs) => {
    return createAsyncThunk(
      thunkName as string,
      // Pre-existing shape: a promise sits where a payload creator belongs.
      apiAction({ ...currentAction, endpoint }, config, args) as never
    );
  };
};
